export default __webpack_public_path__ + "static/media/Quick Reference Guide - Caption App.385ef166.pdf";